import { useEffect } from "react";
import { GuideStoreHook } from "./createGuideStore";

// Opens the guide once per user. Marks it seen on open so a reload mid-guide does not replay it.
export const useAutoOpenGuide = (store: GuideStoreHook, when = true) => {
  useEffect(() => {
    if (!when) return;
    const guide = store.getState();
    if (!guide.seen) {
      guide.openGuide();
      guide.markSeen();
    }
  }, [store, when]);
};
